var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Communication_1-line-63") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 14c0-0.050-0.050-0.15-0.1-0.2l-15-12.5c-0.1-0.1-0.25-0.1-0.3 0l-15 12.5c-0.050 0.050-0.1 0.1-0.1 0.2v0 17c0 0.15 0.1 0.25 0.25 0.25h30c0.15 0 0.25-0.1 0.25-0.25v-17zM1.25 14.5l9.3 6.5-9.3 9.4v-15.9zM11.65 20.65c0.85-0.85 2.5-1.4 4.35-1.4s3.5 0.5 4.35 1.4l10.1 10.1h-28.85l10.050-10.1zM21.4 21l9.35-6.5v15.9l-9.35-9.4zM16 1.85l14.6 12.15-9.55 6.65-0.35-0.35c-0.95-0.95-2.7-1.55-4.7-1.55s-3.75 0.55-4.7 1.55l-0.35 0.35-9.55-6.65 14.6-12.15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.45cd37a96e1278cb6629c8296b5c671f.svg";
export { ForwardRef as ReactComponent };